import { connect } from 'react-redux';

import { IState } from '../../store';
import { AdditionalFeatures, IAdditionalFeaturesProps } from './index';
import { AdditionalFeaturesCommercial, IAdditionalFeaturesCommercialProps } from './AdditionalFeaturesCommercial';

export function mapStateToProps(state: IState): IAdditionalFeaturesProps {
  return {
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
  };
}

export const AdditionalFeaturesContainer = connect<IAdditionalFeaturesProps, {}, {}>(mapStateToProps)(
  AdditionalFeatures,
);

export const AdditionalFeaturesCommercialContainer = connect<IAdditionalFeaturesCommercialProps, {}, {}>(
  mapStateToProps,
)(AdditionalFeaturesCommercial);
